export const L_BANNER_WIDTH_SCALE = 0.2218;

export const L_BANNER_HEIGHT_SCALE = 0.2222;

export const L_BANNER_SAFEGUARD_PERIOD = 30;
